<template>
  <div class="driver-wallet-transaction main">
    <div class="wrapper">
      <!-- <button class="delete is-large" @click="$emit('close')" /> -->
      <!-- <img :src="vehicleIcon" @click="$emit('close')" /> -->
      <img :src="icon" class="is-pulled-right" />
      <h1 class="subtitle" @click="close">
        <i class="fa fa-chevron-left" style="padding-right: 12px" />
        <span>{{ t.workflow_type_name }} Transaction</span>
      </h1>

      <div class="notification">
        <p style="margin-bottom: 8px">
          <i>{{ timestamp }}</i>
          <span class="txn-id" @click="viewDriverRoute">{{ txnID }}</span>
        </p>
        <p>
          <span class="grey">{{ $t("driver.pickup-at") }}</span>
          <span class="location">{{ pickup }}</span>
        </p>
        <p v-if="dropoff">
          <span class="grey">{{ $t("driver.dropoff-at") }}</span>
          <span class="location">{{ dropoff }}</span>
        </p>
        <!-- <hr /> -->
        <div v-if="t.data.fare">
          <div class="is-divider" style="margin: 16px 0" />

          <div class="is-flex">
            <div class="has-text-right" style="flex-shrink: 1">
              <p>
                <span class="grey">Fare:</span>
                <span class="amount">
                  ฿{{ t.data.fare.price - (t.data.fare.bonus || 0) }}
                </span>
              </p>
              <p style="margin-bottom: 6px">
                <span style="padding-bottom: 3px; border-bottom: 1px solid #ccc">
                  <span class="grey">Bonus:</span>
                  <span class="amount">฿{{ t.data.fare.bonus || 0 }}</span>
                </span>
              </p>
              <p class="has-text-weight-bold">
                <span class="grey">{{ $t("total") }}:</span>
                <span class="amount">฿{{ t.data.fare.price }}</span>
              </p>
            </div>

            <div class="has-text-right" style="flex: 1">
              <p>
                <span class="grey">{{ $t("cash") }}:</span>
                <span class="amount"> ฿{{ t.data.fare.cash }} </span>
              </p>
              <p style="margin-bottom: 6px">
                <span style="padding-bottom: 3px; border-bottom: 1px solid #ccc">
                  <span class="grey">TukPay:</span>
                  <span class="amount">฿{{ t.data.fare.tukpay }}</span>
                </span>
              </p>
              <p class="has-text-weight-bold">
                <span class="grey">{{ $t("total") }}:</span>
                <span class="amount">฿{{ t.data.fare.price }}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="disputeStatus" class="dispute" @click="gotoDisputeDistance">
          {{ $t("driver.dispute-distance") }}
          <span class="is-pulled-right has-text-weight-bold">
            <span v-if="disputeStatus === 'ongoing'" class="has-text-warning">{{ $t("orders.ongoing") }} <i
                class="fa fa-spinner fa-spin" /></span>
            <span v-if="disputeStatus === 'granted'" class="has-text-success">{{ $t("driver.granted") }}
              <i class="fa fa-check-circle" /> &nbsp;+{{ disputeExtra }}
            </span>
            <span v-if="disputeStatus === 'declined'" class="has-text-danger">{{ $t("driver.declined") }} <i
                class="fa fa-times-circle" /></span>
          </span>
        </div>
      </div>

      <div v-if="isDelivery" class="notification">
        <span class="button is-rounded is-outlined is-info is-pulled-right" style="padding: 12px"
          @click="viewCommerceDetails">
          <i class="fa fa-receipt is-pulled-right" />
        </span>
        <div v-if="paymentRequired" class="has-text-dark">
          <p v-html="payShopX" />
          <p v-html="collectFromCustomerX" />
          <div class="is-divider" style="margin: 16px 0" />
          <div v-if="isSuperUser()" class="is-pulled-right" @click="preClearRemit">
            <span class="tag has-text-weight-bold"><i class="fa fa-shipping-fast fa-sm has-text-grey" />&nbsp;
              {{ t.data.fare.remit || 0 }}</span>
            <span class="tag has-text-weight-bold"><i class="fa fa-store-alt fa-sm has-text-grey" />&nbsp;
              {{ t.data.delivery.remit || 0 }}</span>
            <span class="tag is-rounded has-text-info"><i class="fa fa-pencil-alt" /></span>
          </div>
          <p v-html="remitToManagerX" class="has-text-link" />
        </div>
        <div v-else class="has-text-dark">
          {{ $t("delivery.already-paid-for") }}
        </div>
      </div>

      <div v-if="requireReceipt" class="notification" @click="editReceiptPrice">
        <div v-if="receiptPrice" class="has-text-info">
          <i class="fa fa-pencil-alt is-pulled-right has-text-success" />
          <p>{{ $t("driver.receipt-paid") }} ฿{{ receiptPrice }}</p>
          <p class="has-text-weight-bold">
            {{ $t("driver.your-profit") }} ฿{{ orderProfit }}
          </p>
        </div>
        <div v-else>
          <span class="button is-rounded is-fullwidth is-warning pulse">
            {{ $t("driver.enter-receipt-price") }}
          </span>
        </div>
      </div>

      <div v-if="showUndo" class="notification" @click="preUndoCompleted">
        <span class="button has-text-success has-text-weight-semibold">
          <i class="fa fa-redo-alt fa-flip" />&nbsp;{{ $t("undo") }}</span>
        <span class="button is-light is-pulled-right">{{ $t("driver.not-yet-completed") }}?</span>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

// import RideSetLocation from "@/components/RideSetLocation.vue";

export default {
  components: {
    // RideSetLocation,
  },
  props: {
    t: Object,
  },
  data() {
    return {
      commerceOrder: null,
    };
  },
  computed: {
    disputeStatus() {
      if (!this.commerceOrder) return;
      return this.commerceOrder.data.distance_dispute_status;
    },
    disputeExtra() {
      return this.commerceOrder.data.distance_dispute_tukpay;
    },
    showUndo() {
      return this.secondsAgo(this.t.updated_at) < 60 * 30; // 30 minutes
    },
    txnID() {
      return this.t.id.substr(this.t.id.length - 5);
    },
    isDelivery() {
      return this.t.workflow_type_name === "Delivery";
    },
    requireReceipt() {
      if (!this.isDelivery) return false;
      return this.t.data.delivery.require_receipt;
    },
    receiptPrice() {
      //   return 33;
      return this.t.data.receipt_price;
    },
    icon() {
      if (this.isDelivery) return "/img/home2/logistics.svg";
      return "/img/home2/ride.svg";
    },
    timestamp() {
      return new Date(this.t.updated_at).toLocaleString("en-GB");
    },
    pickup() {
      return this.t.data.pickup_stop.name || this.$t("ride.pin-location");
    },
    dropoff() {
      if (!this.t.data.dropoff_stop) return null;
      return this.t.data.dropoff_stop.name || this.$t("ride.pin-location");
    },
    payShopX() {
      var orderValue = this.t.data.delivery.order_value;
      var amount = `<strong>${this.symbol}${orderValue}</strong>`;
      return this.$t("delivery.pay-shop-x", { x: amount });
    },
    collectFromCustomerX() {
      var amount = `<strong>${this.symbol}${this.driverCollectValue}</strong>`;
      return this.$t("delivery.collect-from-customer-x", { x: amount });
    },
    remitToManagerX() {
      var amount = `<strong>${this.symbol}${this.remitValue}</strong>`;
      return this.$t("delivery.remit-to-manager-x", { x: amount });
    },
    remitValue() {
      return this.fareRemit + this.orderRemit;
    },
    clientCash() {
      return parseInt(this.t.data.fare.client || this.t.data.fare.cash); // for backward compatability
    },
    fareRemit() {
      return parseInt(this.t.data.fare.remit || 0);
    },
    orderRemit() {
      return parseInt(this.t.data.delivery.remit || 0);
    },
    orderValue() {
      return parseInt(this.t.data.delivery.order_value);
    },
    orderProfit() {
      return this.driverCollectValue - this.receiptPrice;
    },
    paymentRequired() {
      if (!this.isDelivery) return false;
      if (!this.orderValue) return false;
      var arr = ["cash", "promptpay", "bank-transfer"];
      return arr.includes(this.t.data.delivery.payment_method);
      // if (this.t.data.delivery.payment_method === "cash") return true;
      // return false;
    },
    driverCollectValue() {
      // return parseInt(this.orderValue) + parseInt(this.t.data.fare.cash);
      return this.orderValue + this.clientCash + this.orderRemit;
    },
    symbol() {
      return this.currencySymbol("th"); //this.t.business.country);
    },
  },
  mounted() {
    this.getCommerceOrder();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    viewDriverRoute() {
      if (this.isSuperUser()) this.gotoDisputeDistance();
    },
    gotoDisputeDistance() {
      this.goto("/driver_route/" + this.t.data.commerce_transaction_id);
    },
    preClearRemit() {
      this.$swal({
        html: `Clear remit for delivery?`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        confirmButtonText: "Clear Remit"
      }).then(val => {
        if (val.value) {
          // hit API
          // t.data.fare.remit = 0
          // t.data.delivery.remit = 0
        }
      })
    },
    preUndoCompleted() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-exclamation-triangle'></i>&nbsp;Are you sure?
        </p>
        <p style='margin-bottom:10px'>
        This will re-activate the job and show the customer that it is still ENROUTE.
        </p>
        <p>You can only do this once per job, and you should not do it frequently.</p>
        </div>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Put job back in ENROUTE state",
        cancelButtonText: this.$t("no"),
        confirmButtonColor: this.bulmaColor("danger"),
        cancelButtonColor: this.bulmaColor("info"),
      }).then((val) => {
        if (val.value) this.undoCompleted();
      });
    },
    undoCompleted() {
      // set back to enroute
      this.log("undo_completed_job", this.t.id);
      // var msg = `⚠️ Driver [ ${this.$store.getters.realName} ] 🙋🏻 forced job back to ENROUTE state`;
      // this.sendSuperuserNotification(msg);
      var loader = this.loadingDots("pink");
      var payload = { id: this.t.id, state: "enroute" };
      this.$store
        .dispatch("forceChangeTransactionState", payload)
        .then((res) => {
          console.log("forceChangeTransactionState", res.data);
          this.successToast("Changed state to enroute");
          this.errorToast("⚠️อย่าทำแบบนี้บ่อยๆ!");
          this.$emit("closeWallet");
          // this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    editReceiptPrice() {
      this.infoToast("Edit receipt price -- coming soon");
    },
    viewCommerceDetails() {
      // if (!this.t.data.commerce_transaction_id) return this.viewOrderDetails();
      if (this.commerceOrder)
        EventBus.$emit("COMMERCE_ORDER_DRIVER_MODAL", this.commerceOrder);
      // else this.viewOrderDetails();

      // var loader = this.loadingDots();
      // this.$store
      //   .dispatch("getTransactionByID", this.t.data.commerce_transaction_id)
      //   .then((res) => {
      //     if (res.data) {
      //       res.data.is_driver = true; // add a flag here for modal to know it's driver viewing
      //       EventBus.$emit("COMMERCE_ORDER_DRIVER_MODAL", res.data);
      //     } else this.viewOrderDetails();
      //   })
      //   .catch((err) => this.apiError(err))
      //   .finally(() => loader.hide());
    },
    getCommerceOrder() {
      if (!this.t.data.commerce_transaction_id) return;
      this.$store
        .dispatch("getTransactionByID", this.t.data.commerce_transaction_id)
        .then((res) => {
          // res.data.is_driver = true; // add a flag here for modal to know it's driver viewing
          this.commerceOrder = res.data;
        })
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: #f5d252; */
  background-color: #4baced;
  /* z-index: 1100; */
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}

.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
}

.subtitle {
  font-weight: 450;
  margin-top: 6px;
  margin-bottom: 16px;
}

.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}

.fa-search {
  color: lightskyblue;
}

.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}

input::-webkit-input-placeholder {
  color: #2693da !important;
  font-weight: 500;
  opacity: 0.8;
}

img {
  height: 36px;
}

.notification {
  padding: 20px;
}

.amount {
  display: inline-block;
  width: 40px;
}

.grey {
  font-weight: 450;
  opacity: 0.8;
  color: rgb(106, 106, 106);
  margin-right: 6px;
}

.location {
  color: var(--link);
}

.txn-id {
  float: right;
  background-color: #bbb;
  color: white;
  font-weight: 500;
  font-size: 0.8em;
  border-radius: 3px;
  padding: 0 3px;
}

.pulse {
  animation: shadow-pulse-green 2s infinite;
}

@keyframes shadow-pulse-green {
  0% {
    box-shadow: 0 0 0 0px lightgreen;
  }

  100% {
    box-shadow: 0 0 0 6px rgba(144, 238, 144, 0.5);
  }
}

.dispute {
  margin-top: 10px;
  padding: 6px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 0 1px grey;
}
</style>